import styled from 'styled-components';
import { pickThemeFontStyles } from '@/theme';
import { FormItem } from '@/components';

export const StyledTextEditorFormItem = styled(FormItem)`
  grid-column: 1 / -1;
  .ql-container p {
    ${pickThemeFontStyles('16', '24')};
  }
`;
